import { Container } from "reactstrap";
import { H5, Image } from "../../../AbstractElements";
import { ComingSoonTitle } from "../../../Constant";
import CountdownData from "../CountdownData";
import { dynamicImage } from "../../../Service/DynamicImage";

const ComingWithVideoBgContainer = () => {
  return (
    <Container fluid className="p-0">
      <div className="comingsoon auth-bg-video">
        <video className="bgvideo-comingsoon" id="bgvid" poster={dynamicImage("other-images/coming-soon-bg.jpg")} playsInline autoPlay muted loop>
          <source src="../assets/video/auth-bg.mp4" type="video/mp4"/>
        </video>
        <div className="comingsoon-inner text-center">
          <Image src={dynamicImage("other-images/logo-login.png")} alt="" />
          <H5>{ComingSoonTitle}</H5>
          <div className="countdown">
          <CountdownData />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ComingWithVideoBgContainer;
